export default __webpack_public_path__ + "cf39194d1cbec4c190c9ac292720c061.png";